// QuerySearch component

import React from 'react'
import { cn } from '../../../../../lib/utils'
import Icon from '../../../Icon'

type QuerySearchProps = {
  value: string
  onDelete: () => void
  isDeleteMode: boolean
  onDeleteModeChange: (isDeleteMode: boolean) => void
}

export const QuerySearch = ({
  value,
  onDelete,
  isDeleteMode,
  onDeleteModeChange,
}: QuerySearchProps) => {
  const handleDeleteClick = () => {
    onDeleteModeChange(true)
  }

  const handleTriggerClick = () => {
    if (isDeleteMode) {
      onDeleteModeChange(false)
    }
  }

  return (
    <div
      className={cn(
        'inline-flex items-stretch p-0.5 bg-background/50 rounded-md text-xs group transition-colors whitespace-nowrap relative',
        'bg-accent',
        isDeleteMode && 'bg-foreground/20',
      )}
    >
      {/* Delete button */}
      {isDeleteMode && (
        <button
          onClick={onDelete}
          className="absolute -top-1.5 -right-1.5 p-1.5 rounded-full bg-foreground/50 hover:bg-foreground/80 transition-colors"
        ></button>
      )}

      {/* Search value */}
      <div
        className={cn(
          'hover:bg-accent/90 transition-colors rounded-md',
          isDeleteMode && 'bg-accent/20',
        )}
      >
        <button
          onClick={handleDeleteClick}
          className="px-1.5 py-0.5 flex items-center gap-1 text-xs min-w-fit h-full w-full"
        >
          <Icon name="Search" size={12} />
          <span className="truncate">{value}</span>
        </button>
      </div>
    </div>
  )
}
